/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import type {
  GetAddressSuggest401Response,
  GetAddressSuggest403Response,
  GetCommonState400Response,
  GetInstruction200Response,
  GetInstruction404Response,
  GetInstructions200Response,
  SearchInstructions200Response,
  SearchInstructions422Response,
} from '../models/index'
import {
  GetAddressSuggest401ResponseFromJSON,
  GetAddressSuggest401ResponseToJSON,
  GetAddressSuggest403ResponseFromJSON,
  GetAddressSuggest403ResponseToJSON,
  GetCommonState400ResponseFromJSON,
  GetCommonState400ResponseToJSON,
  GetInstruction200ResponseFromJSON,
  GetInstruction200ResponseToJSON,
  GetInstruction404ResponseFromJSON,
  GetInstruction404ResponseToJSON,
  GetInstructions200ResponseFromJSON,
  GetInstructions200ResponseToJSON,
  SearchInstructions200ResponseFromJSON,
  SearchInstructions200ResponseToJSON,
  SearchInstructions422ResponseFromJSON,
  SearchInstructions422ResponseToJSON,
} from '../models/index'

export interface GetInstructionRequest {
  slug: string
}

export interface SearchInstructionsRequest {
  query: string
}

/**
 * InstructionsApi - interface
 *
 * @export
 * @interface InstructionsApiInterface
 */
export interface InstructionsApiInterface {
  /**
   * Опубликованная инструкция по slug: полный контент (конструктор — все типы блоков, как в блоге) и привязанные частые вопросы. Неизвестный slug, черновик или запись чужого типа — 404. Требуется подтверждённый email.
   * @summary Инструкция по slug
   * @param {string} slug Slug инструкции
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InstructionsApiInterface
   */
  getInstructionRaw(
    requestParameters: GetInstructionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetInstruction200Response>>

  /**
   * Опубликованная инструкция по slug: полный контент (конструктор — все типы блоков, как в блоге) и привязанные частые вопросы. Неизвестный slug, черновик или запись чужого типа — 404. Требуется подтверждённый email.
   * Инструкция по slug
   */
  getInstruction(
    requestParameters: GetInstructionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetInstruction200Response>

  /**
   * Все опубликованные инструкции личного кабинета (лёгкие карточки, без пагинации; сортировка по meta.extra.sort_order). Черновики отсекаются. Требуется подтверждённый email.
   * @summary Список инструкций
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InstructionsApiInterface
   */
  getInstructionsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetInstructions200Response>>

  /**
   * Все опубликованные инструкции личного кабинета (лёгкие карточки, без пагинации; сортировка по meta.extra.sort_order). Черновики отсекаются. Требуется подтверждённый email.
   * Список инструкций
   */
  getInstructions(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetInstructions200Response>

  /**
   * Полнотекстовый поиск по опубликованным инструкциям (лемматизация запроса, слова объединяются AND; ранжирование по релевантности и дате публикации, лимит 50). Карточки результата — формат списка инструкций. Требуется подтверждённый email.
   * @summary Поиск инструкций
   * @param {string} query Поисковая строка
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InstructionsApiInterface
   */
  searchInstructionsRaw(
    requestParameters: SearchInstructionsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<SearchInstructions200Response>>

  /**
   * Полнотекстовый поиск по опубликованным инструкциям (лемматизация запроса, слова объединяются AND; ранжирование по релевантности и дате публикации, лимит 50). Карточки результата — формат списка инструкций. Требуется подтверждённый email.
   * Поиск инструкций
   */
  searchInstructions(
    requestParameters: SearchInstructionsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<SearchInstructions200Response>
}

/**
 *
 */
export class InstructionsApi
  extends runtime.BaseAPI
  implements InstructionsApiInterface
{
  /**
   * Опубликованная инструкция по slug: полный контент (конструктор — все типы блоков, как в блоге) и привязанные частые вопросы. Неизвестный slug, черновик или запись чужого типа — 404. Требуется подтверждённый email.
   * Инструкция по slug
   */
  async getInstructionRaw(
    requestParameters: GetInstructionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetInstruction200Response>> {
    if (requestParameters['slug'] == null) {
      throw new runtime.RequiredError(
        'slug',
        'Required parameter "slug" was null or undefined when calling getInstruction().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/instructions/{slug}`.replace(
          `{${'slug'}}`,
          encodeURIComponent(String(requestParameters['slug']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetInstruction200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Опубликованная инструкция по slug: полный контент (конструктор — все типы блоков, как в блоге) и привязанные частые вопросы. Неизвестный slug, черновик или запись чужого типа — 404. Требуется подтверждённый email.
   * Инструкция по slug
   */
  async getInstruction(
    requestParameters: GetInstructionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetInstruction200Response> {
    const response = await this.getInstructionRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Все опубликованные инструкции личного кабинета (лёгкие карточки, без пагинации; сортировка по meta.extra.sort_order). Черновики отсекаются. Требуется подтверждённый email.
   * Список инструкций
   */
  async getInstructionsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetInstructions200Response>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/instructions`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetInstructions200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Все опубликованные инструкции личного кабинета (лёгкие карточки, без пагинации; сортировка по meta.extra.sort_order). Черновики отсекаются. Требуется подтверждённый email.
   * Список инструкций
   */
  async getInstructions(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetInstructions200Response> {
    const response = await this.getInstructionsRaw(initOverrides)
    return await response.value()
  }

  /**
   * Полнотекстовый поиск по опубликованным инструкциям (лемматизация запроса, слова объединяются AND; ранжирование по релевантности и дате публикации, лимит 50). Карточки результата — формат списка инструкций. Требуется подтверждённый email.
   * Поиск инструкций
   */
  async searchInstructionsRaw(
    requestParameters: SearchInstructionsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<SearchInstructions200Response>> {
    if (requestParameters['query'] == null) {
      throw new runtime.RequiredError(
        'query',
        'Required parameter "query" was null or undefined when calling searchInstructions().'
      )
    }

    const queryParameters: any = {}

    if (requestParameters['query'] != null) {
      queryParameters['query'] = requestParameters['query']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/instructions/search`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SearchInstructions200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Полнотекстовый поиск по опубликованным инструкциям (лемматизация запроса, слова объединяются AND; ранжирование по релевантности и дате публикации, лимит 50). Карточки результата — формат списка инструкций. Требуется подтверждённый email.
   * Поиск инструкций
   */
  async searchInstructions(
    requestParameters: SearchInstructionsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<SearchInstructions200Response> {
    const response = await this.searchInstructionsRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }
}
